import React from 'react'

export default function TableStateWrapper({
  loading,
  error,
  onRetry,
  loadingText = 'Loading records...',
  className = 'bg-white rounded-lg shadow',
  tableScrollClassName = 'w-full overflow-x-auto overflow-y-auto max-h-[70vh]',
  containerRef,
  children
}) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-8 text-center">
        <div className="text-4xl mb-4">⏳</div>
        <p className="text-gray-600">{loadingText}</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-white rounded-lg shadow p-8 text-center">
        <div className="text-4xl mb-4">⚠️</div>
        <p className="text-red-600">{error}</p>
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition"
        >
          Retry
        </button>
      </div>
    )
  }

  return <div ref={containerRef} className={className}><div className={tableScrollClassName}>{children}</div></div>
}
